import { axiosInstance as request } from '@/api/rest.service'

export const getStates = boardId => request.get(`/to-dos/states?filter[board_id]=${boardId}`)
export const getTodos = boardId => request.get(`/to-dos?filter[board_id]=${boardId}`)
export const updateTask = (id, payload) => request.put(`/to-dos/${id}`, payload)
export const deleteTodo = id => request.delete(`/to-dos/${id}`)
export const getParticipants = () => request.get('/to-dos/owners')
export const updateState = (id, payload) => request.put(`/to-dos/states/${id}`, payload)
export const createState = payload => request.post(`/to-dos/states`, payload)
export const getDeleteConfirmation = id => request.get(`/to-dos/states/${id}/delete-confirmation`)
export const deleteState = id => request.delete(`/to-dos/states/${id}`)
export const getBoards = () => request.get('/to-dos/boards')
